import * as React from 'react';
import { Button, Modal } from 'antd';
import {
	buildWorkOrderCheckComparisonRows,
	getWorkOrderCheckOutcome,
} from '../../utils/InvoiceUtils';
import { WorkOrderCheckAlert } from './WorkOrderCheckAlert';
import { WorkOrderCheckComparisonTable } from './WorkOrderCheckComparisonTable';
import { getWorkOrderCheckSeverity, WorkOrderCheckDocumentLabel } from './workOrderCheckSeverity';

interface WorkOrderCheckModalProps {
	visible: boolean;
	workOrderCheck: any;
	parsedData: any;
	workOrder: any;
	documentLabel?: WorkOrderCheckDocumentLabel;
	onContinue: () => void;
	onCancel: () => void;
}

/**
 * Shown once, right after a parse comes back looking like it belongs somewhere else.
 *
 * It asks, it does not block: the runbook is explicit that this never gates the save, because the
 * person on the screen knows things the model does not. Continuing applies the parse as normal and
 * leaves the same table on the form.
 */
export const WorkOrderCheckModal: React.FC<WorkOrderCheckModalProps> = ({
	visible,
	workOrderCheck,
	parsedData,
	workOrder,
	documentLabel = 'Invoice',
	onContinue,
	onCancel,
}) => {
	const rows = buildWorkOrderCheckComparisonRows(workOrderCheck, parsedData, workOrder);
	const severity = getWorkOrderCheckSeverity(
		getWorkOrderCheckOutcome(workOrderCheck),
		documentLabel
	);

	return (
		<Modal
			visible={visible}
			width={880}
			closable={false}
			maskClosable={false}
			footer={null}
			onCancel={onCancel}
			bodyStyle={{ padding: '24px 24px 16px' }}
			// The AI forms keep their full-screen invoice Drawer open behind this question, and antd
			// gives Drawer and Modal the same default z-index of 1000 — leaving the winner to portal
			// mount order. One above puts it beyond doubt.
			zIndex={1001}
		>
			<div className="flex flex-col gap-y-m">
				<WorkOrderCheckAlert
					title={severity.title}
					subtitle={severity.subtitle}
					iconClassName={severity.iconClassName}
				/>
				<WorkOrderCheckComparisonTable
					rows={rows}
					invoiceCellClassName={severity.invoiceCellClassName}
					documentLabel={documentLabel}
				/>
				<div className="flex flex-row items-center justify-end gap-x-2">
					<Button onClick={onCancel}>CANCEL</Button>
					<Button type="primary" onClick={onContinue}>
						{severity.continueLabel}
					</Button>
				</div>
			</div>
		</Modal>
	);
};

export default WorkOrderCheckModal;
